<template>
  <div id="footerBox">
    <div class="main-footer">
      <div class="container">
        <div class="lines lines1">
          <div class="inline-blocks icons"></div>
        </div>
        <div class="lines lines3">
          <p>
            <a target="_blank" href="#/about">【公司介绍】</a>
            <a target="_blank" href="#/about">【联系我们】</a>
            <a target="_blank" href="#/privacy">【隐私政策】</a>
            <a target="_blank" href="#/report">【举报指南】</a>
          </p>
          <p>Copyright eaydu. All Rights Reserved</p>
          <p>天津市迅龙通讯科技有限公司 版权所有</p>
          <p>违法/不良信息举报电话：010-52926669</p>
          <p>违法/不良信息举报邮箱：yinxue@tal.com</p>
          <P>
             <a
              href="#/certifate"
              target="_blank"
              rel="noopener noreferrer"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
                color: #889198;
              "
            >
              信息网络传播视听节目许可证号：0210558
            </a>
            </P>
          <p>
            <a
              href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
              target="_blank"
              rel="noopener noreferrer"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
                color: #889198;
              "
            >
              津ICP备 10006026号-8
            </a>
          </p>
          <div style="width: 400px; margin: 0 auto; padding: 20px 0">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=12010102000537"
              style="
                display: inline-block;
                text-decoration: none;
                height: 20px;
                line-height: 20px;
              "
            >
              <img src="../assets/images/beian.png" style="float: left" />
              <p
                style="
                  float: left;
                  height: 20px;
                  line-height: 20px;
                  margin: 0px 0px 0px 5px;
                  color: #939393;
                "
              >
                津公网安备 12010102000537号
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { footer } from "../pages/ossData";
export default {
  data() {
    return {
      footerArr: footer.footerArr,
      footerQR: footer.footerQR,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "../pages/base.scss";
.main-footer {
  min-height: 497px;
  // background: rgba(0, 0, 0, 0.9);
  background-image: url("../assets/images/footer_bg_blackx1.png");
  background-size: 100% 100%;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-family: PingFangSC-Medium, PingFang SC;
  margin-top: vh(48px);
  position: relative;
  z-index: 1;
}

.main-footer .container {
  width: vw(1200px);
  margin: 0 auto;
  padding: 0px;
}

.main-footer .container .img {
  width: vw(246px);
  height: vh(78px);
}

.main-footer .lines1 {
  text-align: left;
}

.main-footer .lines1 .icons {
  margin-top: vh(80px);
  margin-right: vw(120px);
  background-image: url("../assets/images/logo.png");
  width: vw(149.5px);
  height: vh(89.06px);
  background-size: 100% auto;
}
.main-footer .lines1 .icons .images {
  // width: vw(190px);
  // height: vh(78px);
  // background-image: url("../assets/images/miki_logo_dx2.png");
  // margin-bottom: vh(15px);
  // background-size: 100% auto;
}

.main-footer .lines1 .links {
  margin-right: vw(120px);
  vertical-align: top;
  margin-top: vh(30px);
}

.main-footer .lines1 .concacts {
  margin-right: vw(120px);
  vertical-align: top;
  margin-top: vh(30px);
}

.main-footer .lines1 .ours {
  vertical-align: top;
  margin-top: vh(30px);
}

.main-footer .lines1 .ours .images {
  width: vw(232px);
  height: vh(101px);
}

.main-footer .lines1 .ours .images div {
  width: vw(101px);
  height: vh(101px);
}
.main-footer .lines1 .ours .images div:nth-child(2) {
  margin-left: vw(30px);
}
.main-footer .lines1 .concacts .tel {
  font-size: fz(24px);
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: vh(33px);
  letter-spacing: fz(1px);
}

.main-footer .lines1 .concacts .time {
  height: vh(22px);
  font-size: fz(16px);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: vh(22px);
  margin-top: vh(20px);
}

.main-footer .lines1 .concacts .txts {
  height: vh(22px);
  font-size: fz(16px);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: vh(22px);
  margin-top: vh(20px);
}

.inline-blocks {
  display: inline-block;
}

.main-footer .lines1 .txt {
  text-align: center;
}

.main-footer .lines1 .tits {
  margin-bottom: vh(36px);
}
.main-footer .lines .concacts .tits {
  margin-bottom: vh(30px);
}
.main-footer .lines .ours .tits {
  margin-bottom: vh(30px);
}
.marginTop25 {
  margin-top: vh(25px);
}
.marginTop20 {
  margin-top: vh(20px);
}
.marginTop30 {
  margin-top: vh(30px);
}
.marginLeft30 {
  margin-left: vw(30px);
}
.main-footer .lines2 {
  margin-top: vh(20px);
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.9);
  padding-bottom: vh(20px);
}

.main-footer .lines2 .title {
  margin-bottom: vh(25px);
}

.main-footer .lines2 .app {
  width: vw(38px);
  height: vh(70px);
  display: inline-block;
  vertical-align: top;
}
.main-footer .lines2 .app dd {
  overflow: hidden;
  border-radius: 10px;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
}
.main-footer .lines2 .app dl dt {
  font-size: fz(10px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: vh(14px);
  text-align: center;
  margin-top: vh(4px);
}

.main-footer .lines3 {
  position: relative;
  top: -100px;
  margin-top: vh(20px);
  font-size: fz(16px);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(136, 145, 152, 1);
  line-height: vh(36px);
  letter-spacing: fz(1px);
  padding-bottom: vh(35px);
  cursor: pointer;
}

.main-footer .lines3 .links {
  margin-top: vh(20px);
  line-height: 0px;
}
</style>
